import { AnalyticEventCategory, AnalyticEventType, LoginProviderEnum } from '../../../../shared/entity_datas/EntityDatas.ts';
import { CA } from './Analytics.ts';
export var GuestPopupSource = /*#__PURE__*/ function(GuestPopupSource) {
    GuestPopupSource["MilestoneSignup"] = "milestone_signup";
    GuestPopupSource["RoomEntryLogin"] = "room_entry_login";
    return GuestPopupSource;
}({});
function sendGuestPopupAnalytic(type, dimensions) {
    const eventData = {
        type: type,
        category: AnalyticEventCategory.MainFunnel,
        dimensions: dimensions
    };
    void CA.sendAnalyticEvent(eventData);
}
export function sendGuestPopupShown(source) {
    sendGuestPopupAnalytic(AnalyticEventType.GuestPopupShown, {
        source: source
    });
}
export function sendGuestPopupLoginClicked(source, provider) {
    sendGuestPopupAnalytic(AnalyticEventType.GuestPopupLoginClicked, {
        source: source,
        provider: LoginProviderEnum[provider]
    });
}
export function sendGuestPopupContinueAsGuest(source) {
    sendGuestPopupAnalytic(AnalyticEventType.GuestPopupContinueAsGuest, {
        source: source
    });
}
